import mqtt from 'mqtt'

class MqttClient {
  constructor() {
    this.client = null
    this.subscriptions = {}
    this.connectOptions = {
      keepalive: 60,
      clientId: this.generateClientId(), // 默认生成一个
      clean: true,
      reconnectPeriod: 1000,
      connectTimeout: 30 * 1000,
    }
  }

  // 生成随机 ClientId
  generateClientId(prefix = 'vue2_') {
    return prefix + Math.random().toString(16).substr(2, 8)
  }

  // 设置自定义 ClientId
  setClientId(clientId) {
    this.connectOptions.clientId = clientId || this.generateClientId()
  }

  // 连接MQTT服务器
  connect(brokerUrl, options = {}) {
    if (this.client) {
      this.disconnect()
    }

    const connectOpts = { ...this.connectOptions, ...options }
    this.client = mqtt.connect(brokerUrl, connectOpts)

    this.client.on('connect', () => {
      console.log('MQTT Connected with ClientId:', connectOpts.clientId)
      this.onConnect && this.onConnect()
    })

    this.client.on('reconnect', () => {
      console.log('MQTT Reconnecting...')
    })

    this.client.on('error', (error) => {
      console.error('MQTT Error:', error)
      this.onError && this.onError(error)
    })

    this.client.on('message', (topic, message) => {
      const payload = message.toString()
      console.log(`Received message [${topic}]: ${payload}`)
      if (this.subscriptions[topic]) {
        this.subscriptions[topic].forEach(callback => callback(payload, topic))
      }
    })

    this.client.on('close', () => {
      console.log('MQTT Disconnected')
      this.onClose && this.onClose()
    })
  }

  // 断开连接
  disconnect() {
    if (this.client) {
      this.client.end()
      this.client = null
      this.subscriptions = {}
    }
  }

  // 订阅主题
  subscribe(topic, callback) {
    if (!this.client || !this.client.connected) {
      console.error('MQTT client not connected')
      return
    }

    if (!this.subscriptions[topic]) {
      this.subscriptions[topic] = []
      this.client.subscribe(topic, { qos: 0 }, (err) => {
        if (err) {
          console.error('Subscribe error:', err)
        } else {
          console.log(`Subscribed to ${topic}`)
        }
      })
    }

    if (callback && typeof callback === 'function') {
      this.subscriptions[topic].push(callback)
    }
  }

  // 取消订阅
  unsubscribe(topic, callback) {
    if (!this.client || !this.client.connected) {
      console.error('MQTT client not connected')
      return
    }

    if (this.subscriptions[topic]) {
      if (callback) {
        const index = this.subscriptions[topic].indexOf(callback)
        if (index !== -1) {
          this.subscriptions[topic].splice(index, 1)
        }
      } else {
        delete this.subscriptions[topic]
      }

      if (!this.subscriptions[topic] || this.subscriptions[topic].length === 0) {
        this.client.unsubscribe(topic, (err) => {
          if (err) {
            console.error('Unsubscribe error:', err)
          } else {
            console.log(`Unsubscribed from ${topic}`)
          }
        })
        delete this.subscriptions[topic]
      }
    }
  }

  // 发布消息
  publish(topic, message, options = { qos: 0, retain: false }) {
    if (!this.client || !this.client.connected) {
      console.error('MQTT client not connected')
      return
    }

    this.client.publish(topic, message, options, (err) => {
      if (err) {
        console.error('Publish error:', err)
      } else {
        console.log(`Published to ${topic}: ${message}`)
      }
    })
  }
}
export {MqttClient};



// WEBPACK FOOTER //
// ./src/tcode/MqttClient.js